<template> 
  <div class="brokerage" v-title data-title="佣金详情">
    <!-- <header>
      <img src="../../assets/images/card-img/buy-card-img/icon-24-fanhui.png" alt="" @click="$router.replace('/my')"> 
      <p>
        明细详情
      </p>
    </header> -->
    <section>
      <div class="pay-rank">
        <!-- 时间 -->
        <!-- <div class="time">
          <p>
            2020年3月
          </p>
        </div> -->
        <!-- 信息 -->
        <!-- <div class="record_msg" v-for="(item,index) in brokerage_list" :key="index">
          <p class="img">
            <img :src=item.avatar alt="">
          </p>
          <div class="msg">
            <p>
              {{item.fans_name}}
            </p>
            <p>
              {{item.good_name}}
            </p>
            <p>
              {{item.create_time}}
            </p>
          </div>
          <div class="moneyNum">
            <p>{{item.daili}}</p>
            <p>+{{item.brokerage}}</p>
          </div>
        </div> -->
        <router-view></router-view>
      </div>
    </section>
    <footer>
      <brokerageTabar></brokerageTabar>
    </footer>
  </div>
</template>
<script>

import brokerageTabar from '../../components/tabar/brokerage-tabar.'

export default {
  data(){
    return{
      brokerage_list: [], // 佣金列表
    }
  },
  components:{
    brokerageTabar
  },
  created(){

  }
}
</script>
<style lang="less" scoped>
  .brokerage{
    width: 7.5rem;  
    height: 100%;
    background-color: #f0f0f091;
    display: flex;
    flex-direction: column;
    header{
      width: 100%;
      height: .88rem;
      background-color: #ffffff;
      display: flex;
      align-items: center;
      border-bottom: .01rem #E4E4E4 solid;
      img{
        width: .18rem;
        height: .35rem;
        margin-left: .33rem;
      }
      p{
        width: 6.54rem;
        font-family: PingFang-SC-Bold;
        color: #333333;
        font-size: 0.36rem;
        font-weight: bold;
        text-align: center;
      }
    }
    section{
      margin-bottom: .97rem;
      .pay-rank{
        width: 97%;
        height: 100%;
        .time{
          width: 100%;
          height: .88rem;
          background: #F0F0F0;
          p{
            line-height: .88rem;
            margin-left: .29rem;
            font-size: 0.3rem;
            font-family: PingFang SC;
            font-weight: 500;
            color: rgba(51,51,51,1);
          }
        }
        .record_msg{
          width: 98%;
          height: 1.8rem;
          background: #ffffff;
          border-bottom: .01rem #E4E4E4 solid;
          border-radius: 10px; 
          margin: 10px;
          .img{
            height: 1.8rem;
            display: flex;
            align-items: center;
            float: left;
            img{
              width: .92rem;
              height: .92rem;
              margin-left: .51rem;
              border-radius: 0.5rem;
            }
          }
          .msg{
            float: left;
            margin-left: .19rem;
            p{
              margin-top: 0.2rem;
              color: #999999;
              &:first-child{
                margin-top: .26rem;
                font-size: 0.32rem;
                font-family: PingFang SC;
                font-weight: 500;
                color: rgba(51,51,51,1);
                line-height: .32rem;
              }
              &:last-child{
                margin-top: .13rem;
                font-size: 0.24rem;
                font-family: PingFang SC;
                font-weight: 400;
                color: rgba(153,153,153,1);
                line-height: .24rem;
                span{
                  color: red;
                }
              }
            }
          }
          .moneyNum{
            float: right;
            margin-right: .29rem;
            line-height: 1.2rem;
            font-size:0.36rem;
            font-family: Arial;
            font-weight: 400;
            color: rgba(239,130,1,1);
            p{
              &:first-child{
                margin-top: .4rem;
                font-size: 0.25rem;
                font-family: PingFang SC;
                font-weight: 500;
                color: rgba(51,51,51,1);
                line-height: .32rem;
                text-align: center;
              }
              &:last-child{
                margin-top: .29rem;
                font-size: 0.6rem;
                font-family: PingFang SC;
                font-weight: 900;
                color: #e47e32e8;
                line-height: .24rem;
              }
            }
          }
        }
      }
    }
  }
</style>